module.exports = __webpack_public_path__ + "static/media/overview_app_img.80cf7939.png";